import _ from 'underscore';
import { SessionFilterStorage } from './session-filter-storage';
import type { FilterObject, FilterQuery, FilterStorageId, FilterStorageOptions } from './types';

// todo: this logic should really be in summary-tab. will make a query generating
// interface and have the storage users pass in their own version of it.
function mapFeatureNameToEnum(featureName: string) {
  switch (featureName) {
    case 'summary_tab_campaign':
      return 'Enum.CampaignStatus';
    case 'summary_tab_adgroup':
      return 'Enum.AdGroupStatus';
    default:
      return '';
  }
}

function mapFeatureNameToStatusKey(featureName: string) {
  switch (featureName) {
    case 'summary_tab_campaign':
      return 'Campaign/Status';
    case 'summary_tab_adgroup':
      return 'AdGroup/Status';
    default:
      return '';
  }
}

function mapFeatureNameToQuery(featureName: string): FilterQuery {
  switch (featureName) {
    case 'summary_tab_campaign':
      return {
        [mapFeatureNameToStatusKey(featureName)]: {
          $in: [
            `${mapFeatureNameToEnum(featureName)}'Active'`,
            `${mapFeatureNameToEnum(featureName)}'BudgetPaused'`,
          ],
        },
      };
    case 'summary_tab_adgroup':
      return {
        [mapFeatureNameToStatusKey(featureName)]: {
          $in: [
            `${mapFeatureNameToEnum(featureName)}'Active'`,
            `${mapFeatureNameToEnum(featureName)}'CampaignBudgetPaused'`,
          ],
        },
      };
    default:
      return {};
  }
}

export class LegacyQuickFilterStorage extends SessionFilterStorage {
  constructor(options: FilterStorageOptions) {
    if (options.newCampaignsGridFilterEnabled) {
      super(_.extend({}, options, {
        resourceId: 'quick-filter-storage-campaignwebui-CampaignsGrid',
        entryId: 'Campaign/QuickFilter',
      }));
    } else {
      super(options);
    }
  }

  getSessionStorageId({
    featureName,
  }: { featureName?: string }): FilterStorageId {
    switch (featureName) {
      // quick filter saved using the new session filter storage
      case 'summary_tab_adgroup':
        return {
          resourceId: 'quick-filter-storage-campaignwebui-AdgroupGrid',
          entryId: 'AdGroup/QuickFilter',
        };
      default:
        return {
          resourceId: 'quick-filter-storage',
          entryId: `AdsApps(CampaignUI)/Grids(${featureName})/QuickFilter`,
        };
    }
  }

  /**
   * Get legacy quick filter object
   * @return {Object} - Quick filter object that contains
   * key and query
   */
  get() {
    // TODO: based on the scenario entity, decide if we want to also
    // get the waterfall filter.
    return this.storage.find(this.entryId)
      .then((filterEntity: FilterObject) => {
        let key = '';
        if (_.isUndefined(filterEntity.filter)) {
          key = filterEntity.selectedKey;
        } else {
          ({ key } = filterEntity.filter);
        }
        let query = null;

        if (key === 'active') {
          query = mapFeatureNameToQuery(this.featureName);
        }

        return {
          filter: {
            key,
            value: {
              query,
            },
          },
        };
      })
      .catch((): null => null);
  }
}
